

$('.product-descr-drop').click(function(){
  $(this).find('.product-descr-drop-info').toggleClass('product-descr-drop-info-active');
  $(this).toggleClass('product-descr-drop-info-after');
});

$('.popup-btn').click(function(){
  $('.popup-btn-popup').css('display','block');
});
$('.popup-btn-popup-close').click(function(){
  $('.popup-btn-popup').css('display','none');
});

$('.popup-btn2').click(function(){
  $('.popup-btn-popup2').css('display','block');
});
$('.popup-btn-popup-close2').click(function(){
  $('.popup-btn-popup2').css('display','none');
});



// $('.popup-btn').click(function(){

//   let inputHidden = '';
//   $('.product-form__input').each(function(){
//     if($(this).find('.select').length){
//       inputHidden += $(this).find('label').text().replace(/\s+/g, ' ').trim() + ': '+ $(this).find('option:selected').val()+'; ';

//     }else{
//       inputHidden += $(this).find('label').text().replace(/\s+/g, ' ').trim() + ': '+ $(this).find('input:checked').val()+'; ';
//     }
//   });

//   $('#js-data-new').val(inputHidden);

// });


//pdp accordion

$('.product__accordion  summary').click(function(){
  	$(this).find('svg').toggleClass('accordion-svg-rotate');
});


$('.image').first().css('border','1px solid #000');

$('.image').click(function(){

  $('.image').css('border','0px solid #000'); 
  $(this).css('border','1px solid #000');
   
  var dataValueAttr = $(this).attr('data-value');
 
   $('.selcect-color .select__select option:contains('+ dataValueAttr +')').trigger( "click" );

});